import { getUserInfo } from '@/utils/auth'
import { cacheName, cache } from '@/utils/cacheManager'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { getLoading } from '@/utils/utilBaseElement'

/**
 * aiBooking的Context
 */
export class AiBookingContext {
  /**
   * constructor（不需要被vue监听的属性，可以不设置初始值）
   */
  constructor(obj) {
    if (obj instanceof AiBookingContext) {
      this._refObj = obj
      this._data = obj._data
    } else {
      this._data = {
        loading: false,
        office: {},
        config: null
      }
    }
  }
  // 同步引用的对象的数据
  syncData() {
    if (this._refObj) {
      this._refObj._data = this._data
    }
  }
  get loading() {
    return this._data.loading
  }
  set loading(loading) {
    this._data.loading = loading
  }
  get user() {
    if (!this._data.user) {
      this._data.user = getUserInfo()
    }
    return this._data.user
  }
  set user(user) {
    // ignore
  }
  get officeList() {
    return getCacheListByKey(basicCacheKeys.basic_data_Office_All)
  }
  set officeList(officeList) {
    // ignore
  }
  get office() {
    return this._data.office
  }
  set office(office) {
    this._data.office = office
  }
  get config() {
    return this._data.config
  }
  set config(config) {
    this._data.config = config
  }
  /**
   * 准备好数据
   */
  async prepareData(forbidLoading = false) {
    if (!forbidLoading) {
      var loading = getLoading()
    }
    try {
      await cache.load(cacheName.OFFICE, cacheName.CONFIG)
      this.office = cache.office
      this.config = cache.config
    } finally {
      if (!forbidLoading) {
        loading.close()
      }
    }
  }
}
